const categoryCarousels = document.querySelectorAll(".multi-tab-category__carousel");
const categoryTabButtons = document.querySelectorAll(".multi-tab-category__tab-button");
let activeCategoryTabButton = document.querySelector(".multi-tab-category__tab-button.active");
let activeCategoryCarousel = document.querySelector(".multi-tab-category__carousel.active");

categoryTabButtons.forEach((button) => {
  button.addEventListener("click", () => {
    categoryCarousels.forEach((preview) => {
      if (
        button.dataset.tabIndex == preview.dataset.tabIndex &&
        preview !== activeCategoryCarousel
      ) {
        preview.classList.remove("hide-preview");
        activeCategoryTabButton.classList.remove("active");
        button.classList.add("active");
        activeCategoryCarousel.classList.remove("active");
        activeCategoryCarousel.classList.add("hide-preview");
        activeCategoryCarousel = preview;
        activeCategoryTabButton = button;
      }
    });
  });
});
